var _rect, _path, _path2, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentCollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 10,
    width: 30,
    height: 20,
    rx: 4.76946,
    stroke: "url(#paint0_linear_623_3453)",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 15L13.3333 15",
    stroke: "url(#paint1_linear_623_3453)",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.666 25H29.9993",
    stroke: "url(#paint2_linear_623_3453)",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 3.75,
    stroke: "url(#paint3_linear_623_3453)",
    strokeWidth: 2.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_623_3453",
    x1: 5,
    y1: 20,
    x2: 35,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_623_3453",
    x1: 10,
    y1: 15.5,
    x2: 13.3333,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_623_3453",
    x1: 26.666,
    y1: 25.5,
    x2: 29.9993,
    y2: 25.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_623_3453",
    x1: 15,
    y1: 20,
    x2: 25,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F31"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCollection);
export default __webpack_public_path__ + "static/media/payment_collection.88490742796210d809435938e22859bd.svg";
export { ForwardRef as ReactComponent };